// extracted by mini-css-extract-plugin
module.exports = {"label":"ProfilePage_label__1Gmgm"};